import {Component, Input} from '@angular/core';
import {Status} from "../../models/status";
import {StatusHelper} from "../../helpers/status-helper";

@Component({
    selector: 'ldw-status-label',
    templateUrl: './status-label.component.html',
    styleUrls: ['./status-label.component.css'],
    standalone: false
})
export class StatusLabelComponent {

  @Input() status: Status | undefined = undefined;

  getText(): string{
    return (this.status?.text)??"";
  }

  getItemStyle(): string{
      return StatusHelper.getItemStyle(this.status);
  }
}
